module.exports = __webpack_public_path__ + "img/wing_clouds_sun.d3428875.jpg";